import BookCard from "./BookCard";
import {useDispatch, useSelector} from "react-redux";
import {currentBookEdited} from "../redux/edit/actions";
import {useEffect} from "react";
import fetchBooks from "../redux/book/thunk/fetchBooks";
import deleteBook from "../redux/book/thunk/deleteBook";

export default function BookContainer({filter, search}) {
    let books = useSelector((state) => state.books);
    const dispatch = useDispatch();
    console.log('run');
    
    useEffect(() => {
        dispatch(fetchBooks);
    }, [dispatch]);

    books = books.filter(b => b.name.toLowerCase().includes(search.toLowerCase()));
    if (filter === "Featured") {
        books = books.filter(b => b.featured);
    }
    
    const bookDeleteHandler = (bookId) => {
        dispatch(deleteBook(bookId));
    }
    
    const bookEditHandler = (bookId) => {
        dispatch(currentBookEdited(bookId));
    }
    
    return (
        <div className="lws-bookContainer">
            {books.map(b => <BookCard key={b.id} data={b} deleteHandler={bookDeleteHandler} editHandler={bookEditHandler} />)}
        </div>
    );
}